import userReducer from './userReducers';
import { combineReducers } from 'redux';

export default combineReducers({
    myState:userReducer
})